import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDisclosure } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import _ from 'lodash';
import qs from 'qs'
import axios from 'axios';
import { urls } from '../config'

export const NAME = 'NAME'
export const ID_NUMBER = 'ID_NUMBER'
export const MOBILE = 'MOBILE'
export const TEL = 'TEL'
export const PAYMENT_CNT = 'PAYMENT_CNT'
export const MEMO = 'MEMO'
export const amount_per_member = 2000

function isValidDate(dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regEx)) return false;  // Invalid format
    var d = new Date(dateString);
    var dNum = d.getTime();
    if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0, 10) === dateString;
}

const memberSchema = {
    name: Yup.string().required("請輸入姓名"),
    checkDate: Yup.string().required("請輸入檢查日期").test('dateValid',
        '檢查日期格式錯誤',
        (val) => {
            const isValid = isValidDate(val)
            return isValid
        })
};

const validationSchema = Yup.object().shape({
    [NAME]: Yup.string().required('請填寫姓名'),
    [ID_NUMBER]: Yup.string().required('請填寫身份證字號'),
    [MOBILE]: Yup.string().when(TEL, {
        is: "",
        then: Yup.string().required("請填寫手機")
    }),
    [TEL]: Yup.string().when(MOBILE, {
        is: "",
        then: Yup.string().required("請填寫室內電話")
    }),
    [PAYMENT_CNT]: Yup.string().required('請選擇繳款人數'),
    members: Yup.array()
        .of(Yup.object().shape(memberSchema))
        .required("Must have fields")
        .min(1, "Minimum of 1 field"),
}, [[MOBILE, TEL]])

export default function usePaymentForm() {

    const {
        handleSubmit,
        register,
        unregister,
        formState: { errors, isSubmitting },
        control,
        watch
    } = useForm({ resolver: yupResolver(validationSchema), defaultValues:{
        PAYMENT_CNT:1
    } })

    const [totalAmount, setTotalAmount] = useState(0)
    const [urlEnc, setUrlEnc] = useState('')

    useEffect(() => {
        if(urlEnc){
          
            
            document.getElementById("CTBCForm").submit() 
        }        
    }, [urlEnc])
    

    let WATCH_ALL = watch()

    useEffect(() => {
        if (amount_per_member && WATCH_ALL.PAYMENT_CNT) {
            setTotalAmount(amount_per_member * WATCH_ALL.PAYMENT_CNT)
        } else {
            setTotalAmount('')
        }
    }, [WATCH_ALL.PAYMENT_CNT])


    const { isOpen, onOpen, onClose } = useDisclosure()

    function onSubmit(values) {
        onOpen()
    }

    async function onPostData() {
        let memberString = ""

        _.map(WATCH_ALL.members, (item, key) => {
            memberString += `${item.name}|${item.checkDate.replace(/-/g, "")}${key === WATCH_ALL.members.length-1 ? "" : ","}`
        })

        let payload = {
            txtName: WATCH_ALL.NAME,
            txtIdentify: WATCH_ALL.ID_NUMBER,
            txtCell: WATCH_ALL.MOBILE,
            txtPhone: WATCH_ALL.TEL,
            ddlNum: WATCH_ALL.PAYMENT_CNT,
            hidList: memberString,
            txtMemo: WATCH_ALL.MEMO           
        }

  

        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(payload),
            url: urls.encryptUrl,
        };

        const data = await axios(options)

    
        
        if(data.status === 200 && data.data.status){
            setUrlEnc(data.data.data.URLEnc)
        }
    }



    return {
        handleSubmit,
        register,
        unregister,
        errors,
        urlEnc,
        isSubmitting,
        onSubmit,
        onPostData,
        control,
        watch,
        isOpen,
        onOpen,
        onClose,
        totalAmount,
        
    }
}